module.exports = __webpack_public_path__ + "static/media/horn-soli-p2.d60490f6.jpg";